import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import * as _ from "lodash"
import {IwbClaim} from "../PA.Core/PAdbSchemaRowsIF";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {IUsrContext} from "../PA.Core/PA.Core.IF.User";

async function addClaimAgingAuthorizationFilter(findRequest: ISearchRequest): Promise<void> {
    let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
    SearchUtils.addUsrContextSalesOrgFilter(findRequest, 'WB_SALESORG_ID')
    if (usrContext.hasRoleId('VIEW_ALL')) {
        return
    }
    await SearchUtils.addUserGroupCustomerFilter(findRequest, 'WB_CUST_ID_PLANNING')
}

export interface IClaimAgingOptions {
    WbBusinessUnitId?: string,
    WbCustIds?: number[],
    WbClaimTypeIds?: number[],
    Ages: {
        AgeId: string,
        MinDate?: Date,
        MaxDate?: Date
    }[]
}


export interface IClaimAgingResponse {
    AgeResults: {[AgeId: string]: {
            TotalAmt:   number,
            Currency:   string,
            Count:      number,
            wbClaimIds: number[]
        }}
}


export class SettlementMetricsService
{

    static async getClaimAging(options: IClaimAgingOptions): Promise<IClaimAgingResponse> {
        //--
        let opts: IClaimAgingOptions = options || <any> {}


        let returnValue: IClaimAgingResponse = {
            AgeResults: {}
        }

        for(let ageOpts of opts.Ages){
            let queryOptions = {}
            let conditions: any[] = []

            if (_.isDate(ageOpts.MaxDate))
                conditions.push({CLAIM_DT: {lte: DateUtils.convertToSAPBW(ageOpts.MaxDate)}})

            if (_.isDate(ageOpts.MinDate))
                conditions.push({CLAIM_DT: {gte: DateUtils.convertToSAPBW(ageOpts.MinDate)}})

            if(!_.isEmpty(opts.WbCustIds))
                conditions.push({or: [{WB_CUST_ID_PLANNING: {inq: opts.WbCustIds}},{WB_CUST_ID_CLAIM: {inq: opts.WbCustIds}}]})

            if(!_.isEmpty(opts.WbClaimTypeIds))
                conditions.push({WB_CLMTYPE_ID: {inq: opts.WbClaimTypeIds}})
            if(_.isNumber(opts.WbBusinessUnitId))
                conditions.push({WB_BUSINESSUNIT_ID: opts.WbBusinessUnitId})

            if(!_.isEmpty(conditions))
                queryOptions = {and: conditions}

            let findRequest: ISearchRequest = {
                model: 'vUI_Open_Claims',
                where: queryOptions,
                fields: {
                    WB_BUSINESSUNIT_ID:  {type: "number"},
                    WB_SALESORG_ID:      {type: "number"},
                    WB_CLMTYPE_ID:       {type: "number"},
                    WB_CUST_ID_PLANNING: {type: "number"},
                    WB_CUST_ID_CLAIM:    {type: "number"},
                    CLAIM_DT:            {type: "string"}
                }
            }
            await addClaimAgingAuthorizationFilter(findRequest)

            let claimRows: IwbClaim[] = await PASearch.findByRequest(findRequest)

            let entry = {
                Count: 0,
                TotalAmt: 0,
                Currency: '',
                wbClaimIds: <number[]> []
            }

            _.forEach(claimRows, (aClaimRow) => {
                entry.wbClaimIds.push(aClaimRow.WB_CLM_ID)
                entry.Count += 1
                entry.TotalAmt += +(aClaimRow.CLAIM_AMT)
                entry.Currency = aClaimRow.CURRENCY
            })

            returnValue.AgeResults[ageOpts.AgeId] = entry

        } // Next Age


        return returnValue
    }


}